import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/client/src/app/Providers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/components/shared/AppToaster.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/components/shared/NetworkStatus.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/components/shared/TopProgressBar.js");
